(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("keymirror"), require("react"), require("prop-types"), require("react-bootstrap"), require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("base-portlet/js/base-portlet"), require("lwr-client"), require("map-portlet/js/map-portlet"), require("territorial-portlet/js/territorial-portlet"), require("leaflet"));
	else if(typeof define === 'function' && define.amd)
		define(["keymirror", "react", "prop-types", "react-bootstrap", "liferay-widgets-react-web/js/liferay-widgets-react-web", "base-portlet/js/base-portlet", "lwr-client", "map-portlet/js/map-portlet", "territorial-portlet/js/territorial-portlet", "leaflet"], factory);
	else if(typeof exports === 'object')
		exports["fliwas-structure-portlet"] = factory(require("keymirror"), require("react"), require("prop-types"), require("react-bootstrap"), require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("base-portlet/js/base-portlet"), require("lwr-client"), require("map-portlet/js/map-portlet"), require("territorial-portlet/js/territorial-portlet"), require("leaflet"));
	else
		root["fliwas-structure-portlet"] = factory(root["keymirror"], root["react"], root["prop-types"], root["react-bootstrap"], root["liferay-widgets-react-web/js/liferay-widgets-react-web"], root["base-portlet/js/base-portlet"], root["lwr-client"], root["map-portlet/js/map-portlet"], root["territorial-portlet/js/territorial-portlet"], root["leaflet"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_30__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 21.04.2016
	 *
	 */
	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	exports.FeatureRenderer_Group = exports.Group = exports.FliwasMultiOrganizationConfigForm = exports.FliwasOrganizationConfigForm = exports.GlobalFliwasOrganizationsCommuneLayer = exports.GlobalFliwasOrganizationsDistrictLayer = exports.GlobalFliwasOrganizationsRpLayer = exports.GlobalFliwasOrganizationsAllLayer = exports.FliwasOrganizationMasterDetailWidget = exports.FliwasOrganizationMapLinkListItem = exports.FliwasOrganizationDetails = exports.FliwasOrganizationActions = exports.FliwasOrganizationWebApi = exports.map_plugins_FliwasOrganizationDefaultPositionPlugin = exports.FliwasOrganizationDefaultPositionPlugin = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// WebApi
	
	// Actions
	
	//Components
	
	
	var _Constants = __webpack_require__(2);
	
	Object.keys(_Constants).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _Constants[key];
	        }
	    });
	});
	
	var _FliwasOrganizationMapLinkListItem = __webpack_require__(4);
	
	Object.defineProperty(exports, 'FliwasOrganizationMapLinkListItem', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasOrganizationMapLinkListItem).default;
	    }
	});
	
	var _FliwasOrganizationMasterDetailWidget = __webpack_require__(8);
	
	Object.defineProperty(exports, 'FliwasOrganizationMasterDetailWidget', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasOrganizationMasterDetailWidget).default;
	    }
	});
	
	var _StoreFactory = __webpack_require__(13);
	
	Object.keys(_StoreFactory).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _StoreFactory[key];
	        }
	    });
	});
	
	var _FliwasOrganizationConfigForm = __webpack_require__(24);
	
	Object.defineProperty(exports, 'FliwasOrganizationConfigForm', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasOrganizationConfigForm).default;
	    }
	});
	
	var _FliwasMultiOrganizationConfigForm = __webpack_require__(22);
	
	Object.defineProperty(exports, 'FliwasMultiOrganizationConfigForm', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasMultiOrganizationConfigForm).default;
	    }
	});
	
	var _liferayWidgetsReactWeb = __webpack_require__(9);
	
	var _basePortlet = __webpack_require__(10);
	
	__webpack_require__(25);
	
	var _FliwasOrganizationDefaultPositionPlugin = __webpack_require__(29);
	
	var _FliwasOrganizationDefaultPositionPlugin2 = _interopRequireDefault(_FliwasOrganizationDefaultPositionPlugin);
	
	var _FliwasOrganizationWebApi = __webpack_require__(15);
	
	var _FliwasOrganizationWebApi2 = _interopRequireDefault(_FliwasOrganizationWebApi);
	
	var _FliwasOrganizationActions = __webpack_require__(21);
	
	var _FliwasOrganizationActions2 = _interopRequireDefault(_FliwasOrganizationActions);
	
	var _FliwasOrganizationDetails = __webpack_require__(12);
	
	var _FliwasOrganizationDetails2 = _interopRequireDefault(_FliwasOrganizationDetails);
	
	var _FliwasOrganizationFeatureRenderer = __webpack_require__(31);
	
	var _FliwasOrganizationFeatureRenderer2 = _interopRequireDefault(_FliwasOrganizationFeatureRenderer);
	
	var _MapLayer = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.FliwasOrganizationDefaultPositionPlugin = _FliwasOrganizationDefaultPositionPlugin2.default;
	
	
	var MapPlugins = {
	    FliwasOrganizationDefaultPositionPlugin: _FliwasOrganizationDefaultPositionPlugin2.default
	};
	
	var map_plugins_FliwasOrganizationDefaultPositionPlugin = exports.map_plugins_FliwasOrganizationDefaultPositionPlugin = _FliwasOrganizationDefaultPositionPlugin2.default;
	
	Object.keys(MapPlugins).map(function (k) {
	    var name = 'map_plugins_' + k;
	    (0, _liferayWidgetsReactWeb.amdDefine)(name, [], function () {
	        console.log('Defined Map Plugin from Module fliwas-structure ' + name);
	    });
	    return name;
	});
	
	exports.FliwasOrganizationWebApi = _FliwasOrganizationWebApi2.default;
	exports.FliwasOrganizationActions = _FliwasOrganizationActions2.default;
	exports.FliwasOrganizationDetails = _FliwasOrganizationDetails2.default;
	
	
	var GlobalFliwasOrganizationsAllLayer = _extends({}, _MapLayer.FliwasOrganizationsAllLayer, {
	    id: 'fliwas_organizations',
	    uuid: 'fliwas_organizations',
	    controller: _basePortlet.BaseRemoteVectorLayerController
	});
	var GlobalFliwasOrganizationsRpLayer = _extends({}, _MapLayer.FliwasOrganizationsRpLayer, {
	    id: 'fliwas_organizations_rp',
	    uuid: 'fliwas_organizations_rp',
	    controller: _basePortlet.BaseRemoteVectorLayerController
	});
	var GlobalFliwasOrganizationsDistrictLayer = _extends({}, _MapLayer.FliwasOrganizationsDistrictLayer, {
	    id: 'fliwas_organizations_district',
	    uuid: 'fliwas_organizations_district',
	    controller: _basePortlet.BaseRemoteVectorLayerController
	});
	var GlobalFliwasOrganizationsCommuneLayer = _extends({}, _MapLayer.FliwasOrganizationsCommuneLayer, {
	    id: 'fliwas_organizations_commune',
	    uuid: 'fliwas_organizations_commune',
	    controller: _basePortlet.BaseRemoteVectorLayerController
	});
	
	/*const GlobalFliwasOrganizationsAllLayer = {
	    ...FliwasOrganizationsAllLayer,
	    id: 'fliwas_organizations',
	    uuid: 'fliwas_organizations',
	    controller: BaseRemoteDataLayerController
	};
	const GlobalFliwasOrganizationsRpLayer = {
	    ...FliwasOrganizationsRpLayer,
	    id: 'fliwas_organizations_rp',
	    uuid: 'fliwas_organizations_rp',
	    controller: BaseRemoteDataLayerController
	};
	const GlobalFliwasOrganizationsDistrictLayer = {
	    ...FliwasOrganizationsDistrictLayer,
	    id: 'fliwas_organizations_district',
	    uuid: 'fliwas_organizations_district',
	    controller: BaseRemoteDataLayerController
	};
	const GlobalFliwasOrganizationsCommuneLayer = {
	    ...FliwasOrganizationsCommuneLayer,
	    id: 'fliwas_organizations_commune',
	    uuid: 'fliwas_organizations_commune',
	    controller: BaseRemoteDataLayerController
	};*/
	
	exports.GlobalFliwasOrganizationsAllLayer = GlobalFliwasOrganizationsAllLayer;
	exports.GlobalFliwasOrganizationsRpLayer = GlobalFliwasOrganizationsRpLayer;
	exports.GlobalFliwasOrganizationsDistrictLayer = GlobalFliwasOrganizationsDistrictLayer;
	exports.GlobalFliwasOrganizationsCommuneLayer = GlobalFliwasOrganizationsCommuneLayer;
	
	//Widgets
	
	_liferayWidgetsReactWeb.AppContext.registerBundle({
	    webApis: {
	        FliwasOrganizationWebApi: _FliwasOrganizationWebApi2.default
	    }
	});
	
	_FliwasOrganizationActions2.default.itemByGroupId(_Constants.STORE_KEY_CURRENT_ORGANIZATION, { id: _liferayWidgetsReactWeb.AppContext.getScopeGroupId() }); //early load CurrentOrganization*/
	
	var Group = exports.Group = undefined;
	var FeatureRenderer_Group = exports.FeatureRenderer_Group = _FliwasOrganizationFeatureRenderer2.default;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.STORE_KEY_CURRENT_ORGANIZATION = exports.AdministrativeRank = exports.ClassNames = exports.DataNames = exports.ActionTypes = undefined;
	
	var _keymirror = __webpack_require__(3);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _keymirror2.default)({
	    SELECTED_FLIWAS_ORGANIZATION_DETAILS_CONFIG_ID: null
	}); /**
	     * Copyright 2016 xdot GmbH
	     * Author: Marius Runde
	     * Date: 21.04.2016
	     *
	     */
	var DataNames = exports.DataNames = (0, _keymirror2.default)({
	    SELECTED_FLIWAS_ORGANIZATION: null
	});
	
	var ClassNames = exports.ClassNames = (0, _keymirror2.default)({
	    Organization: null,
	    Group: null
	});
	
	var AdministrativeRank = exports.AdministrativeRank = {
	    RP: 3,
	    DISTRICT: 4,
	    COMMUNE: 6
	};
	
	var STORE_KEY_CURRENT_ORGANIZATION = exports.STORE_KEY_CURRENT_ORGANIZATION = 'currentOrganization';

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Carsten Bühler
	 * Date: 07.06.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapLinkListItem = function (_React$Component) {
	    _inherits(MapLinkListItem, _React$Component);
	
	    function MapLinkListItem(props) {
	        _classCallCheck(this, MapLinkListItem);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onClick = _this.onClick.bind(_this);
	        return _this;
	    }
	
	    MapLinkListItem.prototype.onClick = function onClick(e) {
	        this.props.onClick(this.props.item, e);
	    };
	
	    MapLinkListItem.prototype.render = function render() {
	        var _props = this.props,
	            item = _props.item,
	            active = _props.active;
	
	
	        return _react2.default.createElement(
	            _reactBootstrap.ListGroupItem,
	            { className: 'link-list-item ' + (active ? 'active' : ''),
	                disabled: !!item.active,
	                onClick: this.onClick },
	            _react2.default.createElement(
	                'span',
	                {
	                    className: 'link-title' },
	                item.title + (item.parentOrganizationName ? ' (' + item.parentOrganizationName + ')' : '')
	            )
	        );
	    };
	
	    return MapLinkListItem;
	}(_react2.default.Component);
	
	MapLinkListItem.propTypes = _extends({}, _reactBootstrap.ListGroupItem.propTypes, {
	    item: _propTypes2.default.object.isRequired,
	    onClick: _propTypes2.default.func
	});
	
	exports.default = MapLinkListItem;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 21.04.2016
	 *
	 */
	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _liferayWidgetsReactWeb = __webpack_require__(9);
	
	var _basePortlet = __webpack_require__(10);
	
	var _FliwasOrganizationListItem = __webpack_require__(11);
	
	var _FliwasOrganizationListItem2 = _interopRequireDefault(_FliwasOrganizationListItem);
	
	var _FliwasOrganizationDetails = __webpack_require__(12);
	
	var _FliwasOrganizationDetails2 = _interopRequireDefault(_FliwasOrganizationDetails);
	
	var _StoreFactory = __webpack_require__(13);
	
	var _FliwasOrganizationEditForm = __webpack_require__(17);
	
	var _FliwasOrganizationEditForm2 = _interopRequireDefault(_FliwasOrganizationEditForm);
	
	var _FliwasOrganizationNewForm = __webpack_require__(23);
	
	var _FliwasOrganizationNewForm2 = _interopRequireDefault(_FliwasOrganizationNewForm);
	
	var _FliwasOrganizationActions = __webpack_require__(21);
	
	var _FliwasOrganizationActions2 = _interopRequireDefault(_FliwasOrganizationActions);
	
	var _mapPortlet = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//External Plugins
	
	//Current Module
	
	
	//Stores
	var FliwasOrganizationStore = (0, _StoreFactory.getFliwasOrganizationStore)(_liferayWidgetsReactWeb.AppContext);
	
	//DataLinks
	var FliwasOrganizationListLinkCHOC = _liferayWidgetsReactWeb.DataLinkContainer.link(_liferayWidgetsReactWeb.ScrollableDataListRV, ['list', 'activeIds'], (0, _StoreFactory.getFliwasOrganizationStore)(_liferayWidgetsReactWeb.AppContext));
	var FliwasOrganizationDetailsHOC = (0, _liferayWidgetsReactWeb.flagHOC)(_FliwasOrganizationDetails2.default, ['item']);
	var FliwasOrganizationNewFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_FliwasOrganizationNewForm2.default);
	var FliwasOrganizationEditFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_FliwasOrganizationEditForm2.default);
	
	var FliwasOrganizationMasterDetailWidget = function (_React$Component) {
	  _inherits(FliwasOrganizationMasterDetailWidget, _React$Component);
	
	  function FliwasOrganizationMasterDetailWidget(props) {
	    _classCallCheck(this, FliwasOrganizationMasterDetailWidget);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      searchValue: ''
	    };
	
	    _this.DATA = {
	      ORGANIZATIONS: _this.withCtx('_FliwasOrganizations'),
	      FEREDAL_STATE_ORGANIZATIONS: _this.withCtx('_FederalStateOrganizations'),
	      SELECTED_ORGANIZATION: _this.withCtx('_SelectedFliwasOrganization'),
	
	      FORM_NEW_ORGANIZATION: _this.withCtx('_FliwasOrganizationNew'),
	      FORM_EDIT_ORGANIZATION: _this.withCtx('_FliwasOrganizationEdit')
	    };
	
	    _this.searchGroup = (0, _liferayWidgetsReactWeb.debounce)(_this.searchGroup, 300);
	    return _this;
	  }
	
	  FliwasOrganizationMasterDetailWidget.getStores = function getStores() {
	    return [FliwasOrganizationStore];
	  };
	
	  FliwasOrganizationMasterDetailWidget.calculateState = function calculateState(prevState, undefined, DATA) {
	    return {
	      selectedFliwasOrganization: FliwasOrganizationStore.getRemoteData(DATA.SELECTED_ORGANIZATION)
	    };
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.componentDidMount = function componentDidMount() {
	    _FliwasOrganizationActions2.default.listForFederalState(this.DATA.ORGANIZATIONS, {
	      start: 0,
	      end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE
	    });
	    _FliwasOrganizationActions2.default.listFederalStates(this.DATA.FEREDAL_STATE_ORGANIZATIONS, {});
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.componentDidUpdate = function componentDidUpdate() {};
	
	  FliwasOrganizationMasterDetailWidget.prototype.selectFliwasOrganization = function selectFliwasOrganization(fliwasOrganization) {
	    this.changeSelected(fliwasOrganization);
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.changeSelected = function changeSelected(fliwasOrganization) {
	    //Current Object
	    _FliwasOrganizationActions2.default.itemByGroupId(this.DATA.SELECTED_ORGANIZATION, { id: fliwasOrganization.groupId });
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.moreFliwasOrganizations = function moreFliwasOrganizations(query) {
	    _FliwasOrganizationActions2.default.moreItems(this.DATA.ORGANIZATIONS, query);
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.newFliwasOrganization = function newFliwasOrganization() {
	    _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_NEW_ORGANIZATION, {
	      federalState: ''
	    });
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.editFliwasOrganization = function editFliwasOrganization() {
	    var _item = this.state.selectedFliwasOrganization;
	    _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.FORM_EDIT_ORGANIZATION, _item);
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.onFliwasOrganizationEditFormSubmit = function onFliwasOrganizationEditFormSubmit(data) {
	    var res = _FliwasOrganizationActions2.default.updateItem(data, this.DATA.FORM_EDIT_ORGANIZATION, true);
	    console.info('EDIT', res);
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.onFliwasOrganizationNewFormSubmit = function onFliwasOrganizationNewFormSubmit(data) {
	    _FliwasOrganizationActions2.default.createItem(data, this.DATA.FORM_NEW_ORGANIZATION, true);
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.handleChangeNewForm = function handleChangeNewForm(formData, formValidation) {
	    _liferayWidgetsReactWeb.FormActions.changedEditFormItem(this.DATA.FORM_NEW_ORGANIZATION, _extends({}, formData), formValidation);
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.handleChangeEditForm = function handleChangeEditForm(formData, formValidation) {
	    _liferayWidgetsReactWeb.FormActions.changedEditFormItem(this.DATA.FORM_EDIT_ORGANIZATION, _extends({}, formData), formValidation);
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.updateSearchValue = function updateSearchValue(e) {
	    var searchValue = e.target.value;
	    this.searchGroup(searchValue);
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype.searchGroup = function searchGroup(searchValue) {
	    _FliwasOrganizationActions2.default.search(this.DATA.ORGANIZATIONS, {
	      start: 0,
	      end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE,
	      searchValue: searchValue
	    });
	  };
	
	  FliwasOrganizationMasterDetailWidget.prototype._refresh = function _refresh() {
	    var _self = this;
	    _FliwasOrganizationActions2.default.listForFederalState(_self.DATA.ORGANIZATIONS, {
	      start: 0,
	      end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE
	    });
	    _FliwasOrganizationActions2.default.listFederalStates(_self.DATA.FEREDAL_STATE_ORGANIZATIONS, {});
	
	    _self.changeSelected(_self.state.selectedFliwasOrganization.item);
	  };
	
	  /*eslint react/jsx-no-bind: 0*/
	
	
	  FliwasOrganizationMasterDetailWidget.prototype.render = function render() {
	    var searchValue = this.state.searchValue;
	
	
	    var selectedFliwasOrganizationDataItem = this.state.selectedFliwasOrganization && this.state.selectedFliwasOrganization,
	        selectedFliwasOrganization = _liferayWidgetsReactWeb.DataUtil.asItem(selectedFliwasOrganizationDataItem);
	
	    /*eslint react/jsx-no-bind: 0*/
	    return _react2.default.createElement(
	      _reactBootstrap.Container,
	      { fluid: true },
	      _react2.default.createElement(
	        _reactBootstrap.Row,
	        null,
	        _react2.default.createElement(
	          _basePortlet.FliwasObjectMasterDetailList,
	          {
	            searchFunc: this.updateSearchValue.bind(this),
	            createClick: this.newFliwasOrganization.bind(this),
	            refreshClick: this._refresh.bind(this),
	            searchValue: searchValue
	          },
	          _react2.default.createElement(FliwasOrganizationListLinkCHOC, {
	            list: this.DATA.ORGANIZATIONS,
	            size: 'medium',
	            activeIds: this.DATA.SELECTED_ORGANIZATION,
	            ListItem: _FliwasOrganizationListItem2.default,
	            onClick: this.selectFliwasOrganization.bind(this),
	            onClickMore: this.moreFliwasOrganizations.bind(this)
	          })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Col,
	          { lg: 9, md: 12, sm: 12, xs: 12 },
	          _react2.default.createElement(
	            _reactBootstrap.Row,
	            null,
	            _react2.default.createElement(FliwasOrganizationNewFormHoc, {
	              formId: this.DATA.FORM_NEW_ORGANIZATION,
	              federalStatesDataList: this.DATA.FEREDAL_STATE_ORGANIZATIONS,
	              handleBoundingBoxChange: this.handleChangeNewForm.bind(this),
	              handleGeometryChange: this.handleChangeNewForm.bind(this),
	              onFormSubmit: this.onFliwasOrganizationNewFormSubmit.bind(this),
	              context: {
	                contextId: this.props.portletId
	              }
	            }),
	            _react2.default.createElement(FliwasOrganizationEditFormHoc, {
	              formId: this.DATA.FORM_EDIT_ORGANIZATION,
	              federalStatesDataList: this.DATA.FEREDAL_STATE_ORGANIZATIONS,
	              handleGeometryChange: this.handleChangeEditForm.bind(this),
	              handleBoundingBoxChange: this.handleChangeEditForm.bind(this),
	              onFormSubmit: this.onFliwasOrganizationEditFormSubmit.bind(this),
	              context: {
	                contextId: this.props.portletId
	              }
	            }),
	            !selectedFliwasOrganizationDataItem && _react2.default.createElement(
	              _reactBootstrap.Col,
	              { lg: 12, md: 12, sm: 12, xs: 12 },
	              _react2.default.createElement(_basePortlet.SelectObjectErrorMessage, { content: _liferayWidgetsReactWeb.translation.trans('choose-fliwas-client') })
	            ),
	            selectedFliwasOrganizationDataItem && _react2.default.createElement(
	              _reactBootstrap.Col,
	              { lg: 12, md: 12, sm: 12, xs: 12 },
	              _react2.default.createElement(
	                _reactBootstrap.Row,
	                { className: 'padding-box px-0' },
	                _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { lg: 6, md: 12, sm: 12, xs: 12 },
	                  _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { variant: 'primary', title: 'Bearbeiten',
	                      onClick: this.editFliwasOrganization.bind(this) },
	                    'Bearbeiten'
	                  ),
	                  _react2.default.createElement(FliwasOrganizationDetailsHOC, { item: selectedFliwasOrganization })
	                ),
	                selectedFliwasOrganization && selectedFliwasOrganization.geometry && _react2.default.createElement(
	                  _reactBootstrap.Col,
	                  { lg: 6, md: 12, sm: 12, xs: 12 },
	                  _react2.default.createElement(_mapPortlet.Map, {
	                    defaultFallbackMapConfigType: 'static',
	                    plugins: [_mapPortlet.FeatureDisplayPlugin, _mapPortlet.PrintPlugin],
	                    features: [selectedFliwasOrganizationDataItem]
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return FliwasOrganizationMasterDetailWidget;
	}(_react2.default.Component);
	
	FliwasOrganizationMasterDetailWidget.propTypes = {
	  portletId: _propTypes2.default.string.isRequired
	};
	
	exports.default = _liferayWidgetsReactWeb.ContextContainer.create(FliwasOrganizationMasterDetailWidget);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 21.04.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FliwasOrganizationListItem = function (_React$Component) {
	    _inherits(FliwasOrganizationListItem, _React$Component);
	
	    function FliwasOrganizationListItem() {
	        _classCallCheck(this, FliwasOrganizationListItem);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	        _this.onClick = _this.onClick.bind(_this);
	        return _this;
	    }
	
	    FliwasOrganizationListItem.prototype.onClick = function onClick(e) {
	        this.props.onClick(this.props.item, e);
	    };
	
	    FliwasOrganizationListItem.prototype.render = function render() {
	        var _props = this.props,
	            item = _props.item,
	            otherProps = _objectWithoutProperties(_props, ['item']);
	
	        return _react2.default.createElement(
	            _reactBootstrap.ListGroupItem,
	            _extends({}, otherProps, { onClick: this.onClick }),
	            item.title + ' ' + (item.parentOrganizationName ? '(' + item.parentOrganizationName + ')' : '')
	        );
	    };
	
	    return FliwasOrganizationListItem;
	}(_react2.default.Component);
	
	FliwasOrganizationListItem.propTypes = _extends({}, _reactBootstrap.ListGroupItem.propTypes, {
	    item: _propTypes2.default.object.isRequired,
	    onClick: _propTypes2.default.func
	});
	
	exports.default = FliwasOrganizationListItem;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 21.04.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _liferayWidgetsReactWeb = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FliwasOrganizationDetails = function FliwasOrganizationDetails(_ref) {
	    var item = _ref.item;
	
	    item = item && (item.item || item);
	
	    return !item ? _react2.default.createElement(
	        'div',
	        null,
	        'Kein Element gew\xE4hlt'
	    ) : _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: item.title, id: item.id }),
	        _react2.default.createElement(
	            _reactBootstrap.Row,
	            { className: 'border-box' },
	            item.parentOrganizationName && _react2.default.createElement(
	                _reactBootstrap.Col,
	                { lg: 12, md: 12, sm: 12, xs: 12 },
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    _liferayWidgetsReactWeb.translation.trans('federal-state'),
	                    ':'
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    item.parentOrganizationName
	                )
	            ),
	            item.groupFriendlyURL && _react2.default.createElement(
	                _reactBootstrap.Col,
	                { lg: 12, md: 12, sm: 12, xs: 12 },
	                _react2.default.createElement(
	                    'small',
	                    null,
	                    _liferayWidgetsReactWeb.translation.trans('link'),
	                    ':'
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: location.origin + '/group' + item.groupFriendlyURL,
	                            target: '_blank' },
	                        _liferayWidgetsReactWeb.translation.trans('go-to-site')
	                    )
	                )
	            )
	        )
	    );
	};
	
	FliwasOrganizationDetails.propTypes = {
	    item: _propTypes2.default.object
	};
	
	exports.default = FliwasOrganizationDetails;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getFliwasOrganizationStore = getFliwasOrganizationStore;
	
	var _FliwasOrganizationStore = __webpack_require__(14);
	
	var _FliwasOrganizationStore2 = _interopRequireDefault(_FliwasOrganizationStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fliwasOrganizationStoreInstance = void 0; /**
	                                               * Created by Carsten Bühler
	                                               * User: CBuehler on 28.01.2016
	                                               * Copyright: xdot GmbH 2015
	                                               */
	
	function getFliwasOrganizationStore(AppContext) {
	  return fliwasOrganizationStoreInstance || (fliwasOrganizationStoreInstance = AppContext.createStore(_FliwasOrganizationStore2.default));
	}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _liferayWidgetsReactWeb = __webpack_require__(9);
	
	var _Constants = __webpack_require__(2);
	
	var _FliwasOrganizationWebApi = __webpack_require__(15);
	
	var _FliwasOrganizationWebApi2 = _interopRequireDefault(_FliwasOrganizationWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Marius Runde
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 21.04.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var FliwasOrganizationStore = function (_ClassRemoteDataStore) {
	    _inherits(FliwasOrganizationStore, _ClassRemoteDataStore);
	
	    function FliwasOrganizationStore(Dispatcher) {
	        _classCallCheck(this, FliwasOrganizationStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.Group, _FliwasOrganizationWebApi2.default.list, _FliwasOrganizationWebApi2.default.getByGroupId));
	    }
	
	    FliwasOrganizationStore.prototype.reduce = function reduce(state, action) {
	        switch (action.type) {
	
	            case _liferayWidgetsReactWeb.ActionTypesCommon.PAGE_SELECTED:
	                if (this.className == action.meta.className) {
	                    return this.initItem(state, _liferayWidgetsReactWeb.DataNames.PAGE_SELECTED, action.payload, this.defaultItemData);
	                } else {
	                    return this.removeRemoteData(state, _liferayWidgetsReactWeb.DataNames.PAGE_SELECTED);
	                }
	        }
	
	        return _ClassRemoteDataStore.prototype.reduce.call(this, state, action);
	    };
	
	    FliwasOrganizationStore.prototype.extendedWebsocketModelUpdate = function extendedWebsocketModelUpdate(remote, wsUpdate) {
	
	        var newRemote = void 0;
	        if (wsUpdate.content && wsUpdate.content.className === _Constants.ClassNames.Organization) {
	            var storeRemoteEntries = _liferayWidgetsReactWeb.RemoteDataStore.remoteStatetoDataArray(remote);
	            if (storeRemoteEntries && storeRemoteEntries.length > 0) {
	                storeRemoteEntries.forEach(function (remoteEntry) {
	                    if (remoteEntry.item) {
	                        var newItem = _liferayWidgetsReactWeb.RemoteDataStore.invalidateData(remoteEntry);
	                        if (!newRemote) {
	                            newRemote = newRemote || (newRemote = _extends({}, remote));
	                        }
	                        newRemote[remoteEntry.name] = newItem;
	                    }
	                });
	            }
	        }
	        return newRemote || remote;
	    };
	
	    return FliwasOrganizationStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = FliwasOrganizationStore;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(9);
	
	var _lwrClient = __webpack_require__(16);
	
	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 21.04.2016
	 *
	 */
	var fliwasOrganizationService = function fliwasOrganizationService(m, o) {
	    return _lwrClient.Client.invoke('/fliwas_structure.fliwasorganizationapi/' + m, o);
	};
	var fliwasOrganizationServiceWithContext = function fliwasOrganizationServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/fliwas_structure.fliwasorganizationapi/' + m, o, c);
	};
	var administrationService = function administrationService(m, o) {
	    return _lwrClient.Client.invoke('/administration.administrationapi/' + m, o);
	};
	var administrationServiceWithContext = function administrationServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/administration.administrationapi/' + m, o, c);
	};
	
	var api = {
	    get: function get(dataItem) {
	        return fliwasOrganizationServiceWithContext('get.2', {
	            id: dataItem.id,
	            expand: 'NewestAlarmlevel,NewestManualStates'
	        }, {});
	    },
	    listAll: function listAll(query) {
	        return fliwasOrganizationServiceWithContext('list-all.1', {}, {});
	    },
	    listFederalStates: function listFederalStates(query) {
	        return fliwasOrganizationServiceWithContext('list-federal-states.1', {}, {});
	    },
	    search: function search(query) {
	        return fliwasOrganizationServiceWithContext('search.5', {
	            start: query.start,
	            end: query.end,
	            searchValue: query.searchValue,
	            expand: 'NewestAlarmlevel,NewestManualStates'
	        }, {});
	    },
	    list: function list(query) {
	        return fliwasOrganizationServiceWithContext('list.3', {
	            start: query.start,
	            end: query.end
	        }, {});
	    },
	    listForFederalState: function listForFederalState(query) {
	        return fliwasOrganizationServiceWithContext('list-for-federal-state.1', {});
	    },
	    getByGroupId: function getByGroupId(query) {
	        return fliwasOrganizationService('get-by-group-id.2', {
	            groupId: query.id,
	            expand: 'NewestAlarmlevel,NewestManualStates'
	        });
	    },
	    getByGroupIds: function getByGroupIds(query) {
	        return fliwasOrganizationService('get-by-group-ids.2', {
	            groupIds: query.groupIds
	        });
	    },
	    setManualState: function setManualState(query) {
	        return administrationServiceWithContext('set-manual-state.2', {
	            classPK: query.classPK
	        }, {
	            stateId: query.stateId,
	            comment: query.comment,
	            propName: query.propName,
	            className: query.className
	        });
	    },
	    addFliwasOrganization: function addFliwasOrganization(item) {
	        return administrationServiceWithContext('add-fliwas-organization.1', {
	            'name': item.title,
	            'federalState': item.federalState,
	            'territoryIds': item.territoryIds,
	            'administrativeRank': item.administrativeRank,
	            'boundingBox': JSON.stringify(item.boundingBox),
	            geometry: JSON.stringify(item.geometry),
	            'type': item.type,
	            situationMapGroupIds: item.situationMapGroupIds
	        });
	    },
	    resetGroupPermissions: function resetGroupPermissions(groupId) {
	        return administrationServiceWithContext('reset-abnormal-group-permissions.1', {
	            'groupId': groupId
	        }, {});
	    },
	    updateFliwasOrganization: function updateFliwasOrganization(item) {
	        return administrationServiceWithContext('update-fliwas-organization.2', {
	            'id': item.organizationId
	        }, {
	            'name': item.title,
	            'territoryIds': item.territoryIds,
	            'administrativeRank': item.administrativeRank,
	            'boundingBox': JSON.stringify(item.boundingBox),
	            geometry: JSON.stringify(item.geometry),
	            situationMapGroupIds: item.situationMapGroupIds
	        });
	    },
	    getUsedTerritorialEntities: function getUsedTerritorialEntities() {
	        return administrationService('get-used-territorial-entities.0', {});
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('FliwasOrganizationWebApi', api);
	
	exports.default = api;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_16__;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 21.04.2016
	 *
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _liferayWidgetsReactWeb = __webpack_require__(9);
	
	var _basePortlet = __webpack_require__(10);
	
	var _mapPortlet = __webpack_require__(18);
	
	var _TerritorialAreaSelect = __webpack_require__(19);
	
	var _TerritorialAreaSelect2 = _interopRequireDefault(_TerritorialAreaSelect);
	
	var _FliwasMultiOrganizationConfigForm = __webpack_require__(22);
	
	var _FliwasMultiOrganizationConfigForm2 = _interopRequireDefault(_FliwasMultiOrganizationConfigForm);
	
	var _Constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapConfigStore = (0, _mapPortlet.getMapConfigStore)(_liferayWidgetsReactWeb.AppContext);
	var FliwasMultiOrganizationConfigFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_FliwasMultiOrganizationConfigForm2.default);
	
	var validate = function validate(formData) {
	    var titleValid = void 0,
	        territoryIdsValid = void 0,
	        geometryValid = void 0;
	
	    titleValid = _basePortlet.FormValidationUtil.validateStringMinLengthMaxLength(formData.title, 1, 75, 'Titel');
	
	    if (formData.administrativeRank > 0 && formData.administrativeRank !== 99 && !(formData.territoryIds && formData.territoryIds.length > 0)) {
	        territoryIdsValid = 'Bitte Gebiet auswählen!';
	    }
	
	    if (formData.administrativeRank === 99 && !formData.geometry) {
	        geometryValid = 'Bitte Gebiet/Position zeichnen!';
	    }
	
	    return {
	        title: titleValid,
	        territoryIds: territoryIdsValid,
	        geometry: geometryValid
	    };
	};
	
	var ADMINISTRATIVE_RANK_MAP = {
	    3: 'rp',
	    4: 'district',
	    6: 'commune'
	};
	
	var drawOptions = {
	    circle: false,
	    circlemarker: false,
	    marker: false,
	    polyline: false,
	    polygon: true,
	    rectangle: true
	};
	
	var FliwasOrganizationEditForm = function (_React$Component) {
	    _inherits(FliwasOrganizationEditForm, _React$Component);
	
	    function FliwasOrganizationEditForm(props) {
	        _classCallCheck(this, FliwasOrganizationEditForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.props.onChange(_this.props.formData, validate(_this.props.formData));
	        _this.initialTerritories = _this.props.formData.territoryIds;
	        _this.initialAdministrativeRank = _this.props.formData.administrativeRank;
	
	        _this.DATA = {
	            SITUATION_MAPS_GROUP_CHOOSER: _this.props.context.contextId + 'SituationMapsGroupChooser'
	        };
	        return _this;
	    }
	
	    FliwasOrganizationEditForm.prototype.onHandleTerritoryChange = function onHandleTerritoryChange(propName, geometry) {
	        var _extends2;
	
	        var newData = _extends({}, this.props.formData, (_extends2 = {}, _extends2[propName] = geometry, _extends2));
	        this.props.handleGeometryChange(newData, validate(newData));
	    };
	
	    FliwasOrganizationEditForm.prototype.onHandleGeometryChange = function onHandleGeometryChange(geometry) {
	        var newData = _extends({}, this.props.formData, {
	            geometry: geometry
	        });
	        this.props.handleGeometryChange(newData, validate(newData));
	    };
	
	    FliwasOrganizationEditForm.prototype.onHandleBoundingBoxChange = function onHandleBoundingBoxChange(boundingBox) {
	        var newData = _extends({}, this.props.formData, {
	            boundingBox: boundingBox
	        });
	        this.props.handleBoundingBoxChange(newData, validate(newData));
	    };
	
	    FliwasOrganizationEditForm.prototype.changeRank = function changeRank(field, value) {
	        var formData = this.props.formData,
	            item = formData.item || formData;
	
	        var newData = void 0;
	        if (value === 99) {
	            var _extends3;
	
	            newData = _extends({}, item, (_extends3 = {}, _extends3[field] = value, _extends3.territoryIds = [], _extends3));
	        } else {
	            var _extends4;
	
	            newData = _extends({}, item, (_extends4 = {}, _extends4[field] = value, _extends4.territoryIds = value === this.initialAdministrativeRank ? this.initialTerritories : [], _extends4.geometry = undefined, _extends4));
	        }
	
	        this.props.onChange(newData, validate(newData));
	    };
	
	    FliwasOrganizationEditForm.prototype.handleChange = function handleChange(field, e) {
	        this.change(field, e.target.value);
	    };
	
	    FliwasOrganizationEditForm.prototype.change = function change(field, value) {
	        var _extends5;
	
	        var formData = this.props.formData;
	        var item = formData.item || formData;
	
	        var newData = _extends({}, item, (_extends5 = {}, _extends5[field] = value, _extends5));
	
	        this.props.onChange(newData, validate(newData));
	    };
	
	    FliwasOrganizationEditForm.prototype.onSituationMapSelectorClick = function onSituationMapSelectorClick(evt) {
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.SITUATION_MAPS_GROUP_CHOOSER, {
	            activeOrganizationIds: this.props.formData.situationMapGroupIds
	        });
	
	        evt.stopPropagation();
	        evt.preventDefault();
	    };
	
	    FliwasOrganizationEditForm.prototype.onSubmitSituationMapSelection = function onSubmitSituationMapSelection(data) {
	        console.log('onSubmitConfigForm', data);
	        var formData = this.props.formData;
	        var item = formData.item || formData;
	        var newData = _extends({}, item, {
	            situationMapGroupIds: data.activeOrganizationIds
	        });
	
	        this.props.onChange(newData, validate(newData));
	        _liferayWidgetsReactWeb.FormActions.stopEditFormItem(this.DATA.SITUATION_MAPS_GROUP_CHOOSER);
	    };
	
	    FliwasOrganizationEditForm.prototype.render = function render() {
	        var _props = this.props,
	            formData = _props.formData,
	            formValidation = _props.formValidation;
	
	        var administrativeRank = formData && formData.administrativeRank || 0;
	        var defaultMapConfig = _liferayWidgetsReactWeb.DataUtil.asItem(MapConfigStore.getDefaultMapConfig());
	
	        return _react2.default.createElement(
	            _basePortlet.FliwasFormGrid,
	            null,
	            _react2.default.createElement(_basePortlet.FliwasFormHeading, { title: 'Mandanten bearbeiten' }),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                {
	                    title: _liferayWidgetsReactWeb.translation.trans('title'),
	                    formValidation: formValidation,
	                    propName: 'title',
	                    required: true
	                },
	                _react2.default.createElement(_reactBootstrap.FormControl, {
	                    type: 'text',
	                    required: true,
	                    placeholder: _liferayWidgetsReactWeb.translation.trans('title'),
	                    value: formData && formData.title ? formData.title : '',
	                    onChange: this.handleChange.bind(this, 'title')
	                })
	            ),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                {
	                    title: _liferayWidgetsReactWeb.translation.trans('boundingBox'),
	                    formValidation: formValidation,
	                    propName: 'boundingBox',
	                    required: true
	                },
	                _react2.default.createElement(_mapPortlet.GeometryInput, {
	                    hideLabel: true,
	                    nameGeometry: 'boundingBox',
	                    geometry: formData.boundingBox,
	                    type: _Constants.ClassNames.Organization,
	                    handleGeometryChange: this.onHandleBoundingBoxChange.bind(this),
	                    drawOptions: drawOptions,
	                    layerDescriptions: defaultMapConfig && defaultMapConfig.children
	                })
	            ),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                {
	                    title: _liferayWidgetsReactWeb.translation.trans('administrativeRank'),
	                    formValidation: formValidation,
	                    propName: 'administrativeRank'
	                },
	                _react2.default.createElement(_basePortlet.NumberSelect, {
	                    list: [{ value: 3, label: 'Regierungsbezirk' }, { value: 4, label: 'Land-/Stadtkreis' }, { value: 6, label: 'Stadt/Gemeinde' }, { value: 99, label: 'Sonstige' }],
	                    label: _liferayWidgetsReactWeb.translation.trans('type'),
	                    currentValue: administrativeRank,
	                    onChange: this.changeRank.bind(this, 'administrativeRank')
	                })
	            ),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                { title: _liferayWidgetsReactWeb.translation.trans('situationMapSelection') },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            title: 'Mandanten auswählen',
	                            onClick: this.onSituationMapSelectorClick.bind(this),
	                            variant: 'primary',
	                            type: 'button'
	                        },
	                        'Ausw\xE4hlen'
	                    ),
	                    _react2.default.createElement(FliwasMultiOrganizationConfigFormHoc, {
	                        formId: this.DATA.SITUATION_MAPS_GROUP_CHOOSER,
	                        onFormSubmit: this.onSubmitSituationMapSelection.bind(this)
	                    })
	                )
	            ),
	            administrativeRank > 0 && _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                {
	                    title: _liferayWidgetsReactWeb.translation.trans('geometry'),
	                    formValidation: formValidation,
	                    propName: 'geometry',
	                    required: true
	                },
	                administrativeRank !== -1 && administrativeRank !== 99 && _react2.default.createElement(_TerritorialAreaSelect2.default, {
	                    propName: 'territoryIds',
	                    formData: formData,
	                    type: ADMINISTRATIVE_RANK_MAP[administrativeRank],
	                    onChange: this.onHandleTerritoryChange.bind(this)
	                }),
	                administrativeRank === 99 && _react2.default.createElement(_mapPortlet.GeometryInput, {
	                    hideLabel: true,
	                    geometry: formData.geometry,
	                    type: _Constants.ClassNames.Organization,
	                    handleGeometryChange: this.onHandleGeometryChange.bind(this),
	                    drawOptions: drawOptions
	                })
	            )
	        );
	    };
	
	    return FliwasOrganizationEditForm;
	}(_react2.default.Component);
	
	FliwasOrganizationEditForm.propTypes = {
	    formData: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object,
	    drawOptions: _propTypes2.default.object,
	    handleGeometryChange: _propTypes2.default.func,
	    handleBoundingBoxChange: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    context: _propTypes2.default.shape({
	        contextId: _propTypes2.default.string
	    })
	};
	
	exports.default = FliwasOrganizationEditForm;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_18__;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * User: n.gorte
	 * Date: 04.09.2018
	 * Time: 12:30
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _basePortlet = __webpack_require__(10);
	
	var _mapPortlet = __webpack_require__(18);
	
	var _territorialPortlet = __webpack_require__(20);
	
	var _FliwasOrganizationActions = __webpack_require__(21);
	
	var _FliwasOrganizationActions2 = _interopRequireDefault(_FliwasOrganizationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LAYERS = {
	    commune: _territorialPortlet.GlobalTerritorialKommune,
	    district: _territorialPortlet.GlobalTerritorialKreis,
	    rp: _territorialPortlet.GlobalTerritorialRP
	};
	
	var TerritorialAreaSelect = function TerritorialAreaSelect(_ref) {
	    var _ref2;
	
	    var type = _ref.type,
	        onChange = _ref.onChange,
	        _ref$formData = _ref.formData,
	        formData = _ref$formData === undefined ? {} : _ref$formData,
	        propName = _ref.propName;
	
	    var _useState = (0, _react.useState)([]),
	        usedTerritorialEntities = _useState[0],
	        setUsedTerritorialEntities = _useState[1];
	
	    var _useState2 = (0, _react.useState)([]),
	        layerDescriptions = _useState2[0],
	        setLayerDescriptions = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(LAYERS[type]),
	        layer = _useState3[0],
	        setLayer = _useState3[1];
	
	    var initialSelected = (0, _react.useRef)((formData[propName] || []).map(function (id) {
	        return { className: 'TerritorialEntity', id: id };
	    }));
	    var layerController = (0, _react.useRef)(new _basePortlet.BaseRemoteVectorLayerController());
	    layerController.current.onItemClick = function (className, id, title) {
	        return _onChange(id, title);
	    };
	
	    (0, _react.useEffect)(function () {
	        _FliwasOrganizationActions2.default.getUsedTerritorialEntities().then(setUsedTerritorialEntities);
	    }, []);
	
	    (0, _react.useEffect)(function () {
	        var l = LAYERS[type];
	        var layerDescription = _extends({}, l, {
	            zIndex: 999,
	            controller: layerController.current
	        });
	        setLayer(l);
	        setLayerDescriptions([layerDescription]);
	    }, [type]);
	
	    var _onChange = function _onChange(id) {
	        var vals = formData && formData[propName || 'id'].slice() || [];
	
	        var idx = vals.indexOf(id);
	        if (idx >= 0) {
	            vals.splice(idx, 1);
	        } else {
	            vals.push(id);
	        }
	        onChange(propName || 'ids', vals);
	    };
	
	    var selectedIds = formData[propName || 'ids'] || [];
	    var selectedItems = selectedIds && selectedIds.map(function (id) {
	        return { className: 'TerritorialEntity', id: id };
	    });
	
	    var disabledItems = usedTerritorialEntities.map(function (id) {
	        return { className: 'TerritorialEntity', id: id };
	    }).filter(function (item) {
	        return [].concat(selectedItems, initialSelected.current).findIndex(function (s) {
	            return s.id.toString() === item.id.toString();
	        }) < 0;
	    });
	
	    return _react2.default.createElement(_mapPortlet.Map, {
	        selectedItems: selectedItems,
	        disabledItems: disabledItems,
	        defaultFallbackMapConfigType: 'static',
	        plugins: [_mapPortlet.LayerChooserPlugin],
	        layerDescriptions: layerDescriptions,
	        activeUuids: (_ref2 = {}, _ref2[layer.uuid] = true, _ref2),
	        style: { height: 500 },
	        zoom: 12
	    });
	};
	
	TerritorialAreaSelect.propTypes = {
	    onChange: _propTypes2.default.func,
	    formId: _propTypes2.default.string,
	    propName: _propTypes2.default.string,
	    type: _propTypes2.default.string,
	    formData: _propTypes2.default.object
	};
	
	exports.default = TerritorialAreaSelect;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 21.04.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(9);
	
	var _Constants = __webpack_require__(2);
	
	var _FliwasOrganizationWebApi = __webpack_require__(15);
	
	var _FliwasOrganizationWebApi2 = _interopRequireDefault(_FliwasOrganizationWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var className = _Constants.ClassNames.Group;
	
	exports.default = {
	    list: function list(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _FliwasOrganizationWebApi2.default.list);
	    },
	    listForFederalState: function listForFederalState(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _FliwasOrganizationWebApi2.default.listForFederalState);
	    },
	    search: function search(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _FliwasOrganizationWebApi2.default.search);
	    },
	    item: function item(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.item(name, className, query, _FliwasOrganizationWebApi2.default.get);
	    },
	    itemByGroupId: function itemByGroupId(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.item(name, className, query, _FliwasOrganizationWebApi2.default.getByGroupId);
	    },
	    itemsByGroupIds: function itemsByGroupIds(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _FliwasOrganizationWebApi2.default.getByGroupIds);
	    },
	    getUsedTerritorialEntities: function getUsedTerritorialEntities() {
	        return _FliwasOrganizationWebApi2.default.getUsedTerritorialEntities();
	    },
	
	    moreItems: function moreItems(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.moreItems(name, className, query);
	    },
	
	    listFederalStates: function listFederalStates(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _FliwasOrganizationWebApi2.default.listFederalStates);
	    },
	    listAll: function listAll(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, _FliwasOrganizationWebApi2.default.listAll);
	    },
	
	    setManualState: function setManualState(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_FliwasOrganizationWebApi2.default.setManualState, item, formId, closeForm);
	    },
	    createItem: function createItem(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_FliwasOrganizationWebApi2.default.addFliwasOrganization, item, formId, closeForm);
	    },
	    updateItem: function updateItem(item, formId, closeForm) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_FliwasOrganizationWebApi2.default.updateFliwasOrganization, item, formId, closeForm);
	    },
	    resetGroupPermissions: function resetGroupPermissions(groupId) {
	        return _FliwasOrganizationWebApi2.default.resetGroupPermissions(groupId);
	    }
	};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Carsten Hibbeler
	 * Date: 28.01.2016
	 *
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(9);
	
	var _basePortlet = __webpack_require__(10);
	
	var _StoreFactory = __webpack_require__(13);
	
	var _FliwasOrganizationActions = __webpack_require__(21);
	
	var _FliwasOrganizationActions2 = _interopRequireDefault(_FliwasOrganizationActions);
	
	var _FliwasOrganizationMapLinkListItem = __webpack_require__(4);
	
	var _FliwasOrganizationMapLinkListItem2 = _interopRequireDefault(_FliwasOrganizationMapLinkListItem);
	
	var _Constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FliwasOrganizationStore = (0, _StoreFactory.getFliwasOrganizationStore)(_liferayWidgetsReactWeb.AppContext);
	
	var optionsSec = [];
	for (var i = 0; i <= 60; i++) {
	    optionsSec.push(_react2.default.createElement(
	        'option',
	        { value: i * 1000 },
	        i
	    ));
	}
	
	var FliwasMultiOrganizationConfigForm = function (_React$Component) {
	    _inherits(FliwasMultiOrganizationConfigForm, _React$Component);
	
	    function FliwasMultiOrganizationConfigForm(props) {
	        _classCallCheck(this, FliwasMultiOrganizationConfigForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            searchValue: ''
	        };
	        return _this;
	    }
	
	    FliwasMultiOrganizationConfigForm.prototype.search = function search(dataName, query) {
	        _FliwasOrganizationActions2.default.search(dataName, query);
	    };
	
	    FliwasMultiOrganizationConfigForm.prototype.listActive = function listActive(dataName, query) {
	        _FliwasOrganizationActions2.default.itemsByGroupIds(dataName, _extends({}, query, {
	            groupIds: query.activeIds
	        }));
	    };
	
	    FliwasMultiOrganizationConfigForm.prototype.render = function render() {
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: 'Mandanten ausw\xE4hlen', className: 'noborder' }),
	            _react2.default.createElement(_basePortlet.BusinessObjectMultiSelect, {
	                formId: this.props.formId,
	                formData: this.props.formData,
	                onChange: this.props.onChange,
	                className: _Constants.ClassNames.Group,
	                propName: 'activeOrganizationIds',
	                onMore: _FliwasOrganizationActions2.default.moreItems,
	                onSearch: this.search.bind(this),
	                onListActive: this.listActive.bind(this),
	                CustomActiveListMapLinkListItem: _FliwasOrganizationMapLinkListItem2.default,
	                CustomAllListMapLinkListItem: _FliwasOrganizationMapLinkListItem2.default,
	                store: FliwasOrganizationStore,
	                selectedListTitle: 'Ausgew\xE4hlte Mandanten'
	            })
	        );
	    };
	
	    return FliwasMultiOrganizationConfigForm;
	}(_react2.default.Component);
	
	FliwasMultiOrganizationConfigForm.propTypes = {
	    onChange: _propTypes2.default.func,
	    formId: _propTypes2.default.string,
	    formData: _propTypes2.default.object
	};
	
	exports.default = FliwasMultiOrganizationConfigForm;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 21.04.2016
	 *
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(7);
	
	var _liferayWidgetsReactWeb = __webpack_require__(9);
	
	var _basePortlet = __webpack_require__(10);
	
	var _mapPortlet = __webpack_require__(18);
	
	var _StoreFactory = __webpack_require__(13);
	
	var _TerritorialAreaSelect = __webpack_require__(19);
	
	var _TerritorialAreaSelect2 = _interopRequireDefault(_TerritorialAreaSelect);
	
	var _FliwasMultiOrganizationConfigForm = __webpack_require__(22);
	
	var _FliwasMultiOrganizationConfigForm2 = _interopRequireDefault(_FliwasMultiOrganizationConfigForm);
	
	var _Constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FliwasStore = (0, _StoreFactory.getFliwasOrganizationStore)(_liferayWidgetsReactWeb.AppContext);
	var MapConfigStore = (0, _mapPortlet.getMapConfigStore)(_liferayWidgetsReactWeb.AppContext);
	var FliwasMultiOrganizationConfigFormHoc = (0, _liferayWidgetsReactWeb.wrapWithCommonFormContainer)(_FliwasMultiOrganizationConfigForm2.default);
	
	var validate = function validate(formData) {
	    var titleValid = void 0,
	        boundingBoxValid = void 0,
	        federalStateValid = void 0,
	        territoryIdsValid = void 0,
	        geometryValid = void 0;
	
	    titleValid = _basePortlet.FormValidationUtil.validateStringMinLengthMaxLength(formData.title, 1, 75, 'Titel');
	
	    if (!formData.boundingBox) {
	        boundingBoxValid = 'Bitte einen Standardkartenausschnitt zeichnen!';
	    }
	
	    if (formData.administrativeRank > 0 && formData.administrativeRank !== 99 && !(formData.territoryIds && formData.territoryIds.length > 0)) {
	        territoryIdsValid = 'Bitte Gebiet auswählen!';
	    }
	
	    if (formData.administrativeRank === 99 && !formData.geometry) {
	        geometryValid = 'Bitte Gebiet/Position zeichnen!';
	    }
	
	    if (!(formData.federalState && formData.federalState.length > 0)) {
	        federalStateValid = 'Bitte Bundesland auswählen!';
	    }
	
	    return {
	        title: titleValid,
	        boundingBox: boundingBoxValid,
	        territoryIds: territoryIdsValid,
	        geometry: geometryValid,
	        federalState: federalStateValid
	    };
	};
	
	var ADMINISTRATIVE_RANK_MAP = {
	    3: 'rp',
	    4: 'district',
	    6: 'commune'
	};
	
	var drawOptions = {
	    circle: false,
	    circlemarker: false,
	    marker: false,
	    polyline: false,
	    polygon: true,
	    rectangle: true
	};
	
	var FliwasOrganizationNewForm = function (_React$Component) {
	    _inherits(FliwasOrganizationNewForm, _React$Component);
	
	    function FliwasOrganizationNewForm(props) {
	        _classCallCheck(this, FliwasOrganizationNewForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.props.onChange(_this.props.formData, validate(_this.props.formData));
	
	        _this.DATA = {
	            SITUATION_MAPS_GROUP_CHOOSER: _this.props.context.contextId + 'SituationMapsGroupChooser'
	        };
	        return _this;
	    }
	
	    FliwasOrganizationNewForm.prototype.onHandleTerritoryChange = function onHandleTerritoryChange(propName, geometry) {
	        var _extends2;
	
	        var newData = _extends({}, this.props.formData, (_extends2 = {}, _extends2[propName] = geometry, _extends2));
	        this.props.handleGeometryChange(newData, validate(newData));
	    };
	
	    FliwasOrganizationNewForm.prototype.onHandleGeometryChange = function onHandleGeometryChange(geometry) {
	        var newData = _extends({}, this.props.formData, {
	            geometry: geometry
	        });
	        this.props.handleGeometryChange(newData, validate(newData));
	    };
	
	    FliwasOrganizationNewForm.prototype.onHandleBoundingBoxChange = function onHandleBoundingBoxChange(boundingBox) {
	        var newData = _extends({}, this.props.formData, {
	            boundingBox: boundingBox
	        });
	        this.props.handleBoundingBoxChange(newData, validate(newData));
	    };
	
	    FliwasOrganizationNewForm.prototype.changeRank = function changeRank(field, value) {
	        var formData = this.props.formData,
	            item = formData.item || formData;
	
	        var newData = void 0;
	        if (value === 99) {
	            var _extends3;
	
	            newData = _extends({}, item, (_extends3 = {}, _extends3[field] = value, _extends3.territoryIds = [], _extends3));
	        } else {
	            var _extends4;
	
	            newData = _extends({}, item, (_extends4 = {}, _extends4[field] = value, _extends4.territoryIds = [], _extends4.geometry = undefined, _extends4));
	        }
	
	        this.props.onChange(newData, validate(newData));
	    };
	
	    FliwasOrganizationNewForm.prototype.handleChange = function handleChange(field, e) {
	        this.change(field, e.target.value);
	    };
	
	    FliwasOrganizationNewForm.prototype.change = function change(field, value) {
	        var _extends5;
	
	        var formData = this.props.formData;
	        var item = formData.item || formData;
	
	        var newData = _extends({}, item, (_extends5 = {}, _extends5[field] = value, _extends5));
	
	        this.props.onChange(newData, validate(newData));
	    };
	
	    FliwasOrganizationNewForm.prototype.onSituationMapSelectorClick = function onSituationMapSelectorClick(evt) {
	        // 1018
	        _liferayWidgetsReactWeb.FormActions.startEditFormItem(this.DATA.SITUATION_MAPS_GROUP_CHOOSER, {
	            activeOrganizationIds: this.props.formData.situationMapGroupIds
	        });
	
	        evt.stopPropagation();
	        evt.preventDefault();
	    };
	
	    FliwasOrganizationNewForm.prototype.onSubmitSituationMapSelection = function onSubmitSituationMapSelection(data) {
	        // 1018
	        console.log('onSubmitConfigForm', data);
	        var formData = this.props.formData;
	        var item = formData.item || formData;
	        var newData = _extends({}, item, {
	            situationMapGroupIds: data.activeOrganizationIds
	        });
	
	        this.props.onChange(newData, validate(newData));
	        _liferayWidgetsReactWeb.FormActions.stopEditFormItem(this.DATA.SITUATION_MAPS_GROUP_CHOOSER);
	    };
	
	    FliwasOrganizationNewForm.prototype.render = function render() {
	        var _props = this.props,
	            formData = _props.formData,
	            formValidation = _props.formValidation,
	            geometry = formData && formData.geometry,
	            administrativeRank = formData && formData.administrativeRank || 0,
	            boundingBox = formData && (formData.boundingBox || geometry);
	
	
	        var federalStates = _liferayWidgetsReactWeb.DataUtil.asArray(FliwasStore.getRemoteData(this.props.federalStatesDataList)).map(function (i, k) {
	            return {
	                value: i.title,
	                label: i.title
	            };
	        });
	
	        var defaultMapConfig = _liferayWidgetsReactWeb.DataUtil.asItem(MapConfigStore.getDefaultMapConfig());
	
	        return _react2.default.createElement(
	            _basePortlet.FliwasFormGrid,
	            null,
	            _react2.default.createElement(_basePortlet.FliwasFormHeading, { title: 'Mandanten anlegen' }),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                {
	                    title: _liferayWidgetsReactWeb.translation.trans('title'),
	                    formValidation: formValidation,
	                    propName: 'title',
	                    required: true
	                },
	                _react2.default.createElement(_reactBootstrap.FormControl, {
	                    type: 'text',
	                    required: true,
	                    placeholder: _liferayWidgetsReactWeb.translation.trans('title'),
	                    value: formData && formData.title ? formData.title : '',
	                    onChange: this.handleChange.bind(this, 'title')
	                })
	            ),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                {
	                    title: _liferayWidgetsReactWeb.translation.trans('federalState'),
	                    formValidation: formValidation,
	                    propName: 'federalState',
	                    required: true
	                },
	                _react2.default.createElement(_basePortlet.FliwasSelect, {
	                    list: federalStates,
	                    label: _liferayWidgetsReactWeb.translation.trans('federal-state'),
	                    required: true,
	                    onChange: this.handleChange.bind(this, 'federalState')
	                })
	            ),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                {
	                    title: _liferayWidgetsReactWeb.translation.trans('boundingBox'),
	                    formValidation: formValidation,
	                    propName: 'boundingBox',
	                    required: true
	                },
	                _react2.default.createElement(_mapPortlet.GeometryInput, {
	                    hideLabel: true,
	                    nameGeometry: 'boundingBox',
	                    geometry: boundingBox,
	                    type: _Constants.ClassNames.Organization,
	                    handleGeometryChange: this.onHandleBoundingBoxChange.bind(this),
	                    drawOptions: drawOptions,
	                    required: true,
	                    layerDescriptions: defaultMapConfig && defaultMapConfig.children
	                })
	            ),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                {
	                    title: _liferayWidgetsReactWeb.translation.trans('administrativeRank'),
	                    formValidation: formValidation,
	                    propName: 'administrativeRank'
	                },
	                _react2.default.createElement(_basePortlet.NumberSelect, {
	                    list: [{ value: 3, label: 'Regierungsbezirk' }, { value: 4, label: 'Land-/Stadtkreis' }, { value: 6, label: 'Stadt/Gemeinde' }, { value: 99, label: 'Sonstige' }],
	                    label: _liferayWidgetsReactWeb.translation.trans('type'),
	                    currentValue: administrativeRank,
	                    onChange: this.changeRank.bind(this, 'administrativeRank')
	                })
	            ),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                { title: _liferayWidgetsReactWeb.translation.trans('situationMapSelection') },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        _reactBootstrap.Button,
	                        {
	                            title: 'Mandanten auswählen',
	                            onClick: this.onSituationMapSelectorClick.bind(this),
	                            variant: 'primary',
	                            type: 'button'
	                        },
	                        'Ausw\xE4hlen'
	                    ),
	                    _react2.default.createElement(FliwasMultiOrganizationConfigFormHoc, {
	                        formId: this.DATA.SITUATION_MAPS_GROUP_CHOOSER,
	                        onFormSubmit: this.onSubmitSituationMapSelection.bind(this)
	                    })
	                )
	            ),
	            administrativeRank > 0 && _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                {
	                    title: _liferayWidgetsReactWeb.translation.trans('geometry'),
	                    formValidation: formValidation,
	                    propName: 'geometry',
	                    required: true
	                },
	                administrativeRank !== -1 && administrativeRank !== 99 && _react2.default.createElement(_TerritorialAreaSelect2.default, {
	                    propName: 'territoryIds',
	                    formData: formData,
	                    type: ADMINISTRATIVE_RANK_MAP[administrativeRank],
	                    onChange: this.onHandleTerritoryChange.bind(this)
	                }),
	                administrativeRank === 99 && _react2.default.createElement(_mapPortlet.GeometryInput, {
	                    hideLabel: true,
	                    geometry: formData.geometry,
	                    type: _Constants.ClassNames.Organization,
	                    handleGeometryChange: this.onHandleGeometryChange.bind(this),
	                    drawOptions: drawOptions,
	                    layerDescriptions: defaultMapConfig && defaultMapConfig.children
	                })
	            )
	        );
	    };
	
	    return FliwasOrganizationNewForm;
	}(_react2.default.Component);
	
	FliwasOrganizationNewForm.propTypes = {
	    formData: _propTypes2.default.object,
	    formValidation: _propTypes2.default.object,
	    drawOptions: _propTypes2.default.object,
	    federalStatesDataList: _propTypes2.default.string,
	    handleGeometryChange: _propTypes2.default.func,
	    handleBoundingBoxChange: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    context: _propTypes2.default.shape({
	        contextId: _propTypes2.default.string
	    })
	};
	
	exports.default = FliwasOrganizationNewForm;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 30.06.2016
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(9);
	
	var _basePortlet = __webpack_require__(10);
	
	var _FliwasOrganizationActions = __webpack_require__(21);
	
	var _FliwasOrganizationActions2 = _interopRequireDefault(_FliwasOrganizationActions);
	
	var _StoreFactory = __webpack_require__(13);
	
	var _FliwasOrganizationMapLinkListItem = __webpack_require__(4);
	
	var _FliwasOrganizationMapLinkListItem2 = _interopRequireDefault(_FliwasOrganizationMapLinkListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FliwasOrganizationConfigForm = function (_React$Component) {
	    _inherits(FliwasOrganizationConfigForm, _React$Component);
	
	    function FliwasOrganizationConfigForm(props) {
	        _classCallCheck(this, FliwasOrganizationConfigForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.searchOrganizations = (0, _liferayWidgetsReactWeb.debounce)(_this.searchOrganizations.bind(_this), 300);
	        return _this;
	    }
	
	    FliwasOrganizationConfigForm.prototype.withCtx = function withCtx(s) {
	        return this.props.formId + '.' + s;
	    };
	
	    FliwasOrganizationConfigForm.prototype.moreFliwasOrganizations = function moreFliwasOrganizations(listName, query) {
	        _FliwasOrganizationActions2.default.moreItems(listName, query);
	    };
	
	    FliwasOrganizationConfigForm.prototype.searchOrganizations = function searchOrganizations(list, query) {
	        _FliwasOrganizationActions2.default.search(list, _extends({}, query));
	    };
	
	    FliwasOrganizationConfigForm.prototype.change = function change(o) {
	        this.props.onChange(_extends({}, this.props.formData, o));
	    };
	
	    FliwasOrganizationConfigForm.prototype.onChange = function onChange(formData) {
	        this.change(formData);
	    };
	
	    FliwasOrganizationConfigForm.prototype.render = function render() {
	        return _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: 'Bitte Mandanten ausw\xE4hlen' }),
	            _react2.default.createElement(_basePortlet.BusinessObjectSelect, _extends({}, this.props, {
	                formData: this.props.formData,
	                onChange: this.onChange.bind(this),
	                CustomMapLinkListItem: _FliwasOrganizationMapLinkListItem2.default,
	                className: _basePortlet.ClassNames.Group,
	                propName: 'groupId',
	                onMore: this.moreFliwasOrganizations.bind(this),
	                store: (0, _StoreFactory.getFliwasOrganizationStore)(_liferayWidgetsReactWeb.AppContext),
	                onSearch: this.searchOrganizations.bind(this),
	                showMap: false
	            }))
	        );
	    };
	
	    return FliwasOrganizationConfigForm;
	}(_react2.default.Component);
	
	FliwasOrganizationConfigForm.propTypes = {
	    onChange: _propTypes2.default.func,
	    formData: _propTypes2.default.object,
	    formId: _propTypes2.default.string
	};
	
	exports.default = FliwasOrganizationConfigForm;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(26);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(28)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./icons.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/index.js!./icons.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(27)();
	// imports
	
	
	// module
	exports.push([module.id, "[class*=\" icon-fliwas-\"],[class^=icon-fliwas-]{font-family:fliwas-font!important}.icon-fliwas-Group-alarmLevel:before{content:\"\\E90F\"}.icon-fliwas-Group:before{content:\"\\E911\"}", ""]);
	
	// exports


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Hibbeler on 08.02.2016.
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _leaflet = __webpack_require__(30);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _liferayWidgetsReactWeb = __webpack_require__(9);
	
	var _mapPortlet = __webpack_require__(18);
	
	var _StoreFactory = __webpack_require__(13);
	
	var _Constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FliwasOrganizationStore = (0, _StoreFactory.getFliwasOrganizationStore)(_liferayWidgetsReactWeb.AppContext);
	
	var FliwasOrganizationDefaultPositionPlugin = function () {
	    function FliwasOrganizationDefaultPositionPlugin() {
	        _classCallCheck(this, FliwasOrganizationDefaultPositionPlugin);
	    }
	
	    FliwasOrganizationDefaultPositionPlugin.prototype.init = function init(map, o, reEvaluate) {
	        var _this = this;
	
	        this.reEvaluate = reEvaluate;
	        this.removeListener = FliwasOrganizationStore.addListener(this.reEvaluate);
	
	        this.bounds = this.getBounds(o);
	
	        this.zoomToOrganizationControl = _leaflet2.default.Control.extend({
	            options: {
	                position: 'topright'
	            },
	            onAdd: function onAdd(map) {
	                var container = map.zoomControl && map.zoomControl._container || _leaflet2.default.DomUtil.create('div', 'leaflet-bar');
	
	                _this.link = _leaflet2.default.DomUtil.create('a', 'leaflet-control-default-position leaflet-bar-part', container);
	                _leaflet2.default.DomUtil.toBack(_this.link);
	                _this.link.href = '#';
	                _this.link.setAttribute('role', 'button');
	                _this.link.setAttribute('title', 'Zurück zum Mandanten');
	                _this.link.setAttribute('aria-label', 'Zurück zum Mandanten');
	                _this.icon = _leaflet2.default.DomUtil.create('span', 'fa fa-home', _this.link);
	
	                _leaflet2.default.DomEvent.disableClickPropagation(container);
	                _leaflet2.default.DomEvent.on(_this.link, 'click', _leaflet2.default.DomEvent.stop);
	                _leaflet2.default.DomEvent.on(_this.link, 'click', _this.zoomToOrganization.bind(_this, map), _this);
	
	                return container;
	            }
	        });
	        this.control = new this.zoomToOrganizationControl();
	        this.boundRequestHandled = false;
	        this.boundRequestCb = this.boundRequestCb.bind(this);
	        map.addControl(this.control);
	    };
	
	    FliwasOrganizationDefaultPositionPlugin.prototype.initOptions = function initOptions(o) {
	        this.bounds = this.getBounds(o);
	        if (this.bounds && !this.boundRequestHandled) {
	            o.boundRequest = {
	                bounds: this.bounds,
	                options: { animate: false },
	                cb: this.boundRequestCb
	            };
	        }
	        return o;
	    };
	
	    FliwasOrganizationDefaultPositionPlugin.prototype.update = function update(map, o) {
	        var newBounds = this.getBounds(o);
	        if (!this.bounds || !this.bounds.equals(newBounds)) {
	            this.bounds = this.getBounds(o);
	            this.zoomToOrganization(map);
	        }
	    };
	
	    FliwasOrganizationDefaultPositionPlugin.prototype.getBounds = function getBounds(options) {
	        // Portlet config overrides default behaviour. See FLIWASEN-45 https://inovum-dev.de/jira/browse/FLIWASEN-45
	        if (options && options.portletConfig && options.portletConfig.boundingBox) {
	            var bbox = options.portletConfig.boundingBox;
	            return _leaflet2.default.latLngBounds(_leaflet2.default.latLng(bbox.latitudeMin, bbox.longitudeMin), _leaflet2.default.latLng(bbox.latitudeMax, bbox.longitudeMax));
	        } else {
	            var currentOrganization = _liferayWidgetsReactWeb.DataUtil.asItem(FliwasOrganizationStore.getRemoteData(_Constants.STORE_KEY_CURRENT_ORGANIZATION));
	            var boundingBox = currentOrganization && currentOrganization.boundingBox;
	            if (boundingBox) {
	                return _leaflet2.default.latLngBounds(boundingBox.coordinates[0].map(function (point) {
	                    return _leaflet2.default.latLng(point[1], point[0]);
	                }));
	            }
	
	            var geometry = currentOrganization && currentOrganization.geometry;
	            if (geometry) {
	                return (0, _mapPortlet.getBoundsFromGeometry)(geometry);
	            }
	        }
	        return null;
	    };
	
	    FliwasOrganizationDefaultPositionPlugin.prototype.zoomToOrganization = function zoomToOrganization(map) {
	        if (this.bounds) {
	            map.fitBounds(this.bounds);
	        }
	    };
	
	    FliwasOrganizationDefaultPositionPlugin.prototype.remove = function remove() {
	        if (this.removeListener) {
	            this.removeListener.remove();
	        }
	    };
	
	    FliwasOrganizationDefaultPositionPlugin.prototype.boundRequestCb = function boundRequestCb() {
	        this.boundRequestHandled = true;
	    };
	
	    return FliwasOrganizationDefaultPositionPlugin;
	}();
	
	exports.default = FliwasOrganizationDefaultPositionPlugin;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_30__;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _mapPortlet = __webpack_require__(18);
	
	var _Constants = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Hibbeler on 11.02.2016.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var FliwasOrganization = function (_DefaultFeatureRender) {
	    _inherits(FliwasOrganization, _DefaultFeatureRender);
	
	    function FliwasOrganization() {
	        _classCallCheck(this, FliwasOrganization);
	
	        return _possibleConstructorReturn(this, _DefaultFeatureRender.call(this, _Constants.ClassNames.Organization));
	    }
	
	    return FliwasOrganization;
	}(_mapPortlet.DefaultFeatureRendererClass);
	
	exports.default = new FliwasOrganization();

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FliwasOrganizationsCommuneLayer = exports.FliwasOrganizationsDistrictLayer = exports.FliwasOrganizationsRpLayer = exports.FliwasOrganizationsAllLayer = undefined;
	
	var _mapPortlet = __webpack_require__(18);
	
	var _Constants = __webpack_require__(2);
	
	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Carsten Bühler
	 * Date: 22.03.2016
	 *
	 */
	
	var getVectorFeatureGroupStyle = function getVectorFeatureGroupStyle(properties, zoom) {
	    var stateColors = {
	        unknown: '#676a6c',
	        green: '#79e14b',
	        yellow: '#ffe700',
	        orange: '#ffad00',
	        red: '#f00000'
	    };
	
	    var state = properties.overallState;
	    var fillColor = stateColors[state];
	    return {
	        weight: 2,
	        radius: 4,
	        fillColor: fillColor,
	        fillOpacity: 0.4,
	        fill: true
	    };
	};
	
	var FliwasOrganizationsAllLayer = exports.FliwasOrganizationsAllLayer = {
	    id: 'fliwas_organizations',
	    uuid: 'fliwas_organizations',
	    title: 'Mandaten',
	    className: 'Group',
	    api: "FliwasOrganizationWebApi",
	    type: _mapPortlet.ClassNames.LayerDataSource,
	    typeKey: 'remote-vector-layer',
	    params: {},
	    config: {
	        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
	        filter: {
	            'type': 'Group'
	        },
	        style: {
	            color: '#326487',
	            fillColor: '#68869B'
	        },
	        vectorTileLayerStyles: {
	            default: getVectorFeatureGroupStyle
	        }
	    }
	};
	
	var FliwasOrganizationsRpLayer = exports.FliwasOrganizationsRpLayer = {
	    id: 'fliwas_organizations_rp',
	    uuid: 'fliwas_organizations_rp',
	    title: 'Mandaten',
	    className: 'Group',
	    api: "FliwasOrganizationWebApi",
	    type: _mapPortlet.ClassNames.LayerDataSource,
	    typeKey: 'remote-vector-layer',
	    params: {},
	    config: {
	        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
	        filter: {
	            'type': 'Group',
	            'administrativeRank': _Constants.AdministrativeRank.RP
	        },
	        style: {
	            color: '#326487',
	            fillColor: '#68869B'
	        },
	        vectorTileLayerStyles: {
	            default: getVectorFeatureGroupStyle
	        }
	    }
	};
	
	var FliwasOrganizationsDistrictLayer = exports.FliwasOrganizationsDistrictLayer = {
	    id: 'fliwas_organizations_district',
	    uuid: 'fliwas_organizations_district',
	    title: 'Mandaten',
	    className: 'Group',
	    api: "FliwasOrganizationWebApi",
	    type: _mapPortlet.ClassNames.LayerDataSource,
	    typeKey: 'remote-vector-layer',
	    params: {},
	    config: {
	        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
	        filter: {
	            'type': 'Group',
	            'administrativeRank': _Constants.AdministrativeRank.DISTRICT
	        },
	        style: {
	            color: '#326487',
	            fillColor: '#68869B'
	        },
	        vectorTileLayerStyles: {
	            default: getVectorFeatureGroupStyle
	        }
	    }
	};
	
	var FliwasOrganizationsCommuneLayer = exports.FliwasOrganizationsCommuneLayer = {
	    id: 'fliwas_organizations_commune',
	    uuid: 'fliwas_organizations_commune',
	    title: 'Mandaten',
	    className: 'Group',
	    api: "FliwasOrganizationWebApi",
	    type: _mapPortlet.ClassNames.LayerDataSource,
	    typeKey: 'remote-vector-layer',
	    params: {},
	    config: {
	        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
	        filter: {
	            'type': 'Group',
	            'administrativeRank': _Constants.AdministrativeRank.COMMUNE
	        },
	        style: {
	            color: '#326487',
	            fillColor: '#68869B'
	        },
	        vectorTileLayerStyles: {
	            default: getVectorFeatureGroupStyle
	        }
	    }
	};
	
	/*
	export const FliwasOrganizationsAllLayer = {
	    id: 'fliwas_organizations',
	    uuid: 'fliwas_organizations',
	    title: 'Mandaten',
	    type: MapClassNames.LayerDataSource,
	    typeKey: 'remote-data-layer',
	    params: {},
	    config: {
	        params: { "classNames": ["Group"] }
	    }
	};
	export const FliwasOrganizationsRpLayer = {
	    id: 'fliwas_organizations_rp',
	    uuid: 'fliwas_organizations_rp',
	    title: 'Mandaten',
	    type: MapClassNames.LayerDataSource,
	    typeKey: 'remote-data-layer',
	    params: {},
	    config: {
	        params: {
	            "classNames": ["Group"],
	            "administrativeRank": AdministrativeRank.RP
	        }
	    }
	};

	export const FliwasOrganizationsDistrictLayer = {
	    id: 'fliwas_organizations_district',
	    uuid: 'fliwas_organizations_district',
	    title: 'Mandaten',
	    type: MapClassNames.LayerDataSource,
	    typeKey: 'remote-data-layer',
	    params: {},
	    config: {
	        params: {
	            "classNames": ["Group"],
	            "administrativeRank": AdministrativeRank.DISTRICT
	        }
	    }
	};

	export const FliwasOrganizationsCommuneLayer = {
	    id: 'fliwas_organizations_commune',
	    uuid: 'fliwas_organizations_commune',
	    title: 'Mandaten',
	    type: MapClassNames.LayerDataSource,
	    typeKey: 'remote-data-layer',
	    params: {},
	    config: {
	        params: {
	            "classNames": ["Group"],
	            "administrativeRank": AdministrativeRank.COMMUNE
	        }
	    }
	};*/

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// fliwas-structure-portlet.js